module.exports = __webpack_public_path__ + "img/img-error.1c81ad8d.png";